import { Action } from "@ngrx/store";
import { SupportProjects, Vote } from "@edp-models/support-projects.model";

export enum ESupportProjectsActions {
    LoadDonation = "[SupportProjects] Loading Support Projects",
    SaveDonation = "[SupportProjects] Saving Support Projects",
    VoteDonation = "[SupportProjects] Vote Project",
    SetGasCompensation = "[SupportProjects] SetGasCompensation",
}

export class LoadDonation implements Action {
    public readonly type = ESupportProjectsActions.LoadDonation;
    constructor(public eventCode?: string) {}
}

export class SaveDonation implements Action {
    public readonly type = ESupportProjectsActions.SaveDonation;
    constructor(public payload: SupportProjects) {}
}

export class VoteDonation implements Action {
    public readonly type = ESupportProjectsActions.VoteDonation;
    constructor(public payload: SupportProjects) {}
}

export class SetGasCompensation implements Action {
    public readonly type = ESupportProjectsActions.SetGasCompensation;
    constructor(public payload: SupportProjects) {}
}

export type SupportProjectsActions = LoadDonation | SaveDonation | VoteDonation | SetGasCompensation;
